import { PropsWithChildren } from 'react';
import Image from 'next/image';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

export function VisionSection() {
  return (
    <Box as='section' bg='accent.sky.100' borderTopLeftRadius='48px' py={{ base: '40px', md: '80px' }}>
      <ContentContainer>
        <Heading as='h2' size='h1' textAlign='center'>
          At Udacity, we are{' '}
          <Box as='span' color='blue.400' fontWeight='500'>
            forging futures in tech
          </Box>
        </Heading>
        <Text marginTop='8px' marginX='auto' maxWidth='800px' textAlign='center'>
          We are delivering impactful and cutting edge tech education that enables individuals and organizations to
          unlock their potential.
        </Text>
        <Box h='48px' />
        <Flex flexDirection={{ base: 'column', lg: 'row' }} gap='24px'>
          <VisionCard
            color='lime'
            title='Be Outcome Obsessed'
            description='Center our actions around our customers and learners. Derive motivation from and be guided by measurable
        outcomes.'
          >
            <Image alt='' height={53} quality={100} src='/images/about-us/vision_lime.svg' width={53} />
          </VisionCard>
          <VisionCard
            color='purple'
            description='Champion ongoing learning, challenge norms, and encourage healthy debate to foster a workplace of innovation and exploration.'
            title='Embrace Curiosity'
          >
            <Image alt='' height={53} quality={100} src='/images/about-us/vision_purple.svg' width={53} />
          </VisionCard>
          <VisionCard
            color='seafoam'
            description='Give the power to ourselves and others to speak up, take data-driven risks, innovate, and embrace change.'
            title='Take the Lead'
          >
            <Image alt='' height={53} quality={100} src='/images/about-us/vision_seafoam.svg' width={53} />
          </VisionCard>
          <VisionCard
            color='blue'
            description='Collaborate with compassion, respect, and trust. Celebrate the unseen work that makes victories possible.'
            title='Celebrate the Assist'
          >
            <Image alt='' height={53} quality={100} src='/images/about-us/vision_blue.svg' width={53} />
          </VisionCard>
        </Flex>
      </ContentContainer>
    </Box>
  );
}

export function VisionCard({
  title,
  description,
  color,
  children,
}: PropsWithChildren<{
  title: string;
  description: string;
  color: 'lime' | 'purple' | 'seafoam' | 'blue';
}>) {
  const colorMap = {
    lime: 'accent.lime',
    purple: 'accent.purple',
    seafoam: 'accent.sea-foam.500',
    blue: 'accent.sky.500',
  } as const;

  return (
    <Flex
      bgGradient='linear(to-b, #1A1E62, #070933)'
      borderRadius='base'
      flex={1}
      flexDirection='column'
      gap='16px'
      padding='24px'
    >
      {children}
      <Heading as='h3' color={colorMap[color]} lineHeight='36px' size='h3'>
        {title}
      </Heading>
      <Text color='white'>{description}</Text>
    </Flex>
  );
}
